import { z } from 'zod';
import { uuidV7Schema } from '../uuid.js';
/**
 * `RefreshToken` — révocable, jamais stocké en clair (M23) : `tokenHash` est le haché du
 * jeton, la comparaison se fait dessus, une fuite de la base ne donne pas de session
 * utilisable.
 *
 * `revokedAt` se pose sur trois événements — `/auth/logout`, désactivation du compte,
 * réinitialisation du mot de passe — et jamais autrement : ni rotation ni recalcul au
 * démarrage (M23, `🔵 différée`). Pas de purge non plus : `expiresAt` porte la justesse, pas
 * la propreté de la table.
 */
export const refreshTokenSchema = z.object({
    id: uuidV7Schema,
    userId: uuidV7Schema,
    tokenHash: z.string().min(1),
    expiresAt: z.date(),
    revokedAt: z.date().nullable(),
});
//# sourceMappingURL=refresh-token.js.map